var w = /* @__PURE__ */ ((a) => (a.Forward = "Forward", a.Back = "Back", a.Right = "Right", a.Left = "Left", a.Up = "Up", a.Down = "Down", a))(w || {});
export {
  w as Direction
};
//# sourceMappingURL=index7.js.map
